export default {
    indexUserImports:       { method: 'get',    url: 'user_imports' },
    destroyUserImport:      { method: 'delete', url: 'user_imports/{id}'},
    userImportItem:         { method: 'post',   url: '{param}/import'},
    reprocessUserImport:    { method: 'post',   url: 'user_imports/reprocess'},
    indexImports:           { method: 'get',    url: 'user_imports/imports' },
}